import React, { useMemo, useState } from "react";
import { getValue } from "../../utils/object.utils";
import { DropdownOptions } from "../dropdownOptions";
import { SUBJECT_TYPE_OPTIONS } from "../../Constants/options/classType.options";
import { SubjectForm } from "./SubjectForm";
import { Modal, ModalSize } from "../Modal";
import { useUpdateSubject } from "../../hooks/subjectHooks/subject.hooks";
import { validateSubjectForm } from "./validateSubjectForm";
import { useDispatch } from "react-redux";
import { setWarningMessage } from "../../Redux/Slices/alert.slice";

interface Props {
  open: boolean;
  onClose: () => unknown;
  subject: any;
}
export const EditSubjectModal = ({ open, onClose, subject }: Props) => {
  const dispatch = useDispatch();

  const subjectId = getValue(subject, "id");
  const subjectDetails = getValue(subject, "subject_details", []);
  const _subjectName = getValue(subject, "name");
  const _subjectType = getValue(subject, "subject_type");

  const [subjectName, setSubjectName] = useState("");

  const [subjectTypeOption, setSubjectTypeOption] = useState<
    DropdownOptions | null | undefined
  >(null);

  const [subjectClasses, setSubjectClasses] = useState<DropdownOptions[]>([]);

  const { isLoading: isSubjectUpdating, mutate: updateSubject } =
    useUpdateSubject({
      onSuccess: () => {},
      onError: () => {},
    });

  useMemo(() => {
    const selectedClasses = subjectDetails.map((subject: any) => ({
      text: getValue(subject, "class.name"),
      value: getValue(subject, "class_id"),
    }));

    const subjectType = SUBJECT_TYPE_OPTIONS.find(
      ({ value }) => value === _subjectType
    );

    setSubjectTypeOption(subjectType);
    setSubjectClasses(selectedClasses);
    setSubjectName(_subjectName);
  }, [subject]);

  const handleUpdateSubject = () => {
    if (!subjectId) return;

    const errorMessage = validateSubjectForm({
      name: subjectName,
      subject_type: subjectTypeOption?.value as string,
      classIds: subjectClasses as [],
    });

    if (errorMessage) {
      return dispatch(setWarningMessage(errorMessage));
    }

    updateSubject({
      subjectId,
      body: {
        name: subjectName,
        subject_type: subjectTypeOption?.value as string,
        classIds: subjectClasses.map(({ value }) => value),
      },
    });
  };

  return (
    <Modal
      show={open}
      onClose={onClose}
      modalHeader={"Edit subject"}
      modalSize={ModalSize.sm}
      submissionButton={{
        text: "Save",
        onClick: () => {
          handleUpdateSubject();
        },
        isSubmitLoading: isSubjectUpdating,
      }}
    >
      <SubjectForm
        subjectName={subjectName}
        onSubjectNameChange={setSubjectName}
        subjectType={subjectTypeOption as DropdownOptions}
        onSubjectTypeChange={setSubjectTypeOption}
        selectedClass={subjectClasses}
        onClassChange={setSubjectClasses}
      />
    </Modal>
  );
};
